import { JSX } from 'react'

export function parseLucideSvg(svgString: string) {
  const parsed = new DOMParser().parseFromString(svgString, 'image/svg+xml')
  const svg = parsed.documentElement
  const viewBox = svg.getAttribute('viewBox')
  const children = Array.from(svg.children)

  return { svg, viewBox, children }
}

export function getLucidePaths(svgString: string): JSX.Element[] {
  const { children } = parseLucideSvg(svgString)

  return children
    .filter(child => child.tagName !== 'svg')
    .map((child, index) => {
      const element = child as SVGElement
      const Tag = element.tagName as keyof JSX.IntrinsicElements
      const props: Record<string, string | number> = {}

      Array.from(element.attributes).forEach(attr => {
        const name = attr.name === 'class' ? 'className' : attr.name
        props[name] = attr.value
      })

      return <Tag key={index} {...props} />
    })
}
